<template>
  <div class="practice container">
    <div class="box">
      <el-form :model="params" class="search_form" :inline="true" size="small">
        <el-form-item prop="title">
          <el-input v-model="params.title" placeholder="搜索"
            ><el-button
              slot="append"
              size="small"
              icon="el-icon-search"
              @click="getPracticeList"
            ></el-button
          ></el-input>
        </el-form-item>
        <el-form-item prop="taskType">
          <el-radio-group v-model="params.taskType" @change="getPracticeList">
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button label="PERSONAL">个人</el-radio-button>
            <el-radio-button label="TEAM">团队</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            class="add-btn"
            type="primary"
            size="small"
            @click="
              $router.push({
                path: '/assistantMode/courseDetail/practice/practiceBank',
                query: { ...$route.query },
              })
            "
            >实战库</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        class="practice_list"
        :data="list"
        height="calc(100% - 50px - 32px - 20px)"
      >
        <el-table-column prop="title" label="文件名称"> </el-table-column>
        <el-table-column
          prop="taskType"
          width="100"
          label="类型"
          :formatter="formatter"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleDetail(scope.row)"
            >
              {{ scope.row.taskStoreId == 0 ? "查看" : "编辑" }}
            </el-button>
            <el-button
              @click="handleDel(scope.row.taskId)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { practiceList, delPractice } from "@/api/assistantMode/practice";
export default {
  props: {
    info: Object,
  },
  data() {
    return {
      params: {
        title: "",
        classId: this.$route.query.id,
        classChapterId: this.$route.query.classChapterId,
        taskType: null,
      },
      list: [],
      classChapterId: null,
    };
  },
  activated() {
    this.getPracticeList();
  },
  methods: {
    //   列表
    getPracticeList() {
      this.params.classChapterId = this.$route.query.classChapterId;
      this.$loading.show();
      practiceList(this.params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    formatter(row) {
      if (row.taskType == "PERSONAL") {
        return "个人";
      } else if (row.taskType == "TEAM") {
        return "团队";
      }
    },
    // 详情
    handleDetail(row) {
      if (row.taskStoreId == 0)
        this.$router.push({
          path: "/assistantMode/courseDetail/practice/pdf",
          query: { ...this.$route.query },
        });
      else
        this.$router.push({
          path: "/assistantMode/courseDetail/practice/detail",
          query: { ...this.$route.query, taskId: row.taskId },
        });
    },
    // 删除
    handleDel(taskId) {
      this.$confirm("确定要删除该实战吗?", {
        type: "warning",
      })
        .then(() => {
          delPractice(taskId).then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getPracticeList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.practice {
  height: 100%;
  text-align: left;
  .box {
    padding: 25px 35px;
    margin: 30px auto;
    height: calc(100% - 60px);
    background-color: #fff;
    ::v-deep .search_form {
      .el-form-item {
        margin-right: 50px;
        .el-input-group__append {
          background-color: #409eff;
          border-color: #409eff;
          color: #fff;
        }
      }
    }
    ::v-deep .practice_list {
      margin-top: 5px;
      .is-leaf {
        color: #333;
        background-color: #f5f5f5;
      }
    }
  }
}
</style>